export class CasinoService {
    slotCost = 1;
    speed = 5;
    ticks = 10;
    victories = [];
    sounds = [];

    constructor() {
        this.initSound();
        this.setSlotsVictory();
    }

    get casinoData() {
        return $gameSystem.casino_data;
    }

    set chips(value) {
        $gameSystem.casino_data.chips = value;
    }

    get chips() {
        return $gameSystem.casino_data.chips;
    }

    get chipName() {
        return 'Chip';
    }

    isEnabled() {
        return this.chips >= this.slotCost;
    }

    addChips(value) {
        this.chips += value;
        Yosemite.McManager.addToInventory(4, value);
    }

    removeChips() {
        Yosemite.McManager.removeFromInventory(4, this.chips);
        this.chips = 0;
    }

    setSlotCost(value) {
        this.slotCost = value;
    }

    setSlotsVictory() {
        const slots = [
            [0, 1, 0, 1],
            [0, 0, 1, 1],
            [1, 0, 0, 1],
            [0, 0, 0, 10],
            [1, 0, 0, 15],
            [0, 1, 0, 15],
            [0, 0, 1, 15],
            [1, 1, 1, 20],
            [1, 1, 2, 25],
            [1, 2, 1, 25],
            [2, 1, 1, 25],
            [2, 2, 2, 30],
            [2, 2, 3, 35],
            [2, 3, 2, 35],
            [3, 2, 2, 35],
            [3, 3, 3, 40],
            [3, 3, 4, 45],
            [3, 4, 3, 45],
            [4, 3, 3, 45],
            [4, 4, 4, 50],
            [5, 4, 5, 55],
            [4, 5, 5, 55],
            [5, 5, 4, 55],
            [5, 5, 5, 60],
            [5, 6, 5, 65],
            [6, 5, 5, 65],
            [5, 5, 6, 65],
            [6, 6, 6, 70],
            [6, 7, 6, 75],
            [7, 6, 6, 75],
            [6, 6, 7, 75],
            [7, 7, 7, 80],
        ]

        slots.forEach(slot => {
            this.victories.push({
                s1: slot[0],
                s2: slot[1],
                s3: slot[2],
                win: slot[3]
            });
        });
    };

    initSound() {
        this.sounds[0] = {
            name: 'Electrocardiogram',
            pitch: 100,
            volume: 70,
            pan: 0
        }

        this.sounds[1] = {
            name: 'Reflection',
            pitch: 100,
            volume: 70,
            pan: 0
        }
    }
}
